export default __webpack_public_path__ + "static/media/A0.dd8fa6e8.mp3";